import { render, staticRenderFns } from "./TermsAcknowledgement.vue?vue&type=template&id=2f986198"
import script from "./TermsAcknowledgement.vue?vue&type=script&lang=js"
export * from "./TermsAcknowledgement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports